<template>
  <svg width="20"
       height="20"
       viewBox="0 0 20 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M5.81641 19.4629C6.31738 19.4629 6.68652 19.2168 7.29297 18.6807L10.3076 16.0264H15.5986C18.2441 16.0264 19.7295 14.4971 19.7295 11.8867V5.05762C19.7295 2.44727 18.2441 0.917969 15.5986 0.917969H4.39258C1.75586 0.917969 0.261719 2.44727 0.261719 5.05762V11.8867C0.261719 14.5059 1.7998 16.0264 4.33105 16.0264H4.69141V18.1797C4.69141 18.9619 5.10449 19.4629 5.81641 19.4629ZM6.25586 17.4941V14.9893C6.25586 14.4707 6.02734 14.2686 5.53516 14.2686H4.4541C2.80176 14.2686 2.01074 13.4336 2.01074 11.834V5.11035C2.01074 3.51074 2.80176 2.67578 4.4541 2.67578H15.5459C17.1895 2.67578 17.9805 3.51074 17.9805 5.11035V11.834C17.9805 13.4336 17.1895 14.2686 15.5459 14.2686H10.2109C9.6748 14.2686 9.41113 14.3564 9.04199 14.7432L6.25586 17.4941ZM5.76367 9.78613C6.48438 9.78613 7.06445 9.19727 7.06445 8.46777C7.06445 7.74707 6.48438 7.1582 5.76367 7.1582C5.03418 7.1582 4.44531 7.74707 4.44531 8.46777C4.44531 9.19727 5.03418 9.78613 5.76367 9.78613ZM10 9.78613C10.7207 9.78613 11.3096 9.19727 11.3096 8.46777C11.3096 7.74707 10.7207 7.1582 10 7.1582C9.2793 7.1582 8.69043 7.74707 8.69043 8.46777C8.69043 9.19727 9.2793 9.78613 10 9.78613ZM14.2451 9.78613C14.9658 9.78613 15.5547 9.19727 15.5547 8.46777C15.5547 7.74707 14.9658 7.1582 14.2451 7.1582C13.5244 7.1582 12.9355 7.74707 12.9355 8.46777C12.9355 9.19727 13.5244 9.78613 14.2451 9.78613Z"
          :fill="color"/>
  </svg>
</template>

<script>
export default {
  name: 'DialogIcon',
  props: {
    width: {
      type: Number,
      default: 16
    },
    height: {
      type: Number,
      default: 18
    },
    color: {
      type: String,
      default: '#B6BEC7'
    }
  }

}
</script>

<style>

</style>
